module.exports = __webpack_public_path__ + "img/delivered.5df21fe5.svg";